export default __webpack_public_path__ + "static/11_V1@2x-548a88c0d77add8756f43b4401fa99f7.png";